import React from "react";

import Container from "react-bootstrap/Container";
import FormContact from "../../components/form/ContactMeForm/FormContact";
import { Fade } from "react-awesome-reveal";

import "./ContactMe.css";

const ContactMe: React.FC = () => {
  return (
    <section id="contact">
      <Container className="container-box rounded">
        <svg
          className="svg__contact"
          viewBox="0 0 200 200"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#00CED1"
            d="M30.3,-24C39.3,-12.8,46.7,-0.3,43.3,8C39.9,16.3,25.8,20.3,14.8,22.3C3.9,24.3,-3.9,24.3,-12.3,21.8C-20.7,19.2,-29.7,14,-34.4,4.6C-39.2,-4.8,-39.6,-18.3,-33.2,-28.9C-26.7,-39.5,-13.4,-47.1,-1.4,-46C10.6,-44.9,21.3,-35.2,30.3,-24Z"
            transform="translate(100 100)"
          />
        </svg>
        <Fade duration={2000} triggerOnce>
          <h1 className="pt-3 text-center font-details-b pb-3">Let's talk</h1>
          <p className="text-center">
            I'm interested in new oportunities - especially ambitious or large
            projects. If you have any request or question, don't hesitate to
            contact me.
          </p>
          <FormContact />
        </Fade>
      </Container>
    </section>
  );
};
export default ContactMe;
